// extracted by mini-css-extract-plugin
export var orderSummary = "_o4-0";
export var showMoreLessButton = "_o4-1";